{
  "#OBJEKT": {
    "RESULT": {
      "OBJEKT": {
        "OBJEKT": "Objekt",
        "ID": "ID",
        "NUMMER": "Nummer",
        "NAME": "Name",
        "GEODATEN": "Geodaten"
      },
      "GEODATEN": {
        "GEODATEN": "Geodaten",
        "ID": "ID",
        "GPSBREITE": "GPS-Breite",
        "GPSLAENGE": "GPS-Länge",
        "GOOGLE_MAPS": "Google Maps"
      },
      "DOCUMENTS": "Dokumente"
    },
    "INPUT": {
      "OBJEKTAUSWAHL": "Objektauswahl",
      "OBJEKT_AUSWAEHLEN_TEXT": "Bitte wählen Sie das gewünschte Objekt aus, um dann automatisch zur Detail-Seite weitergeleitet zu werden.",
      "PLACEHOLDER_TEXT": "Objekt auswählen/suchen"
    }
  }
}
